import moment from 'moment';
import { MOVE_IN_VERIFY_ERROR_CODES } from 'config/app-config';

import { FUEL_TYPES, METER_TYPES, DATE_FORMAT } from 'config/app-config';

export const getFuelType = ({ gas, electric }) => {
  switch (true) {
    case gas && electric:
      return 'dual';
    case gas:
      return FUEL_TYPES.GAS;
    default:
      return FUEL_TYPES.ELECTRIC;
  }
};

export const hasSmartMetter = (
  { electric, gas },
  electricityMeter = {},
  gasMeter = {}
) => {
  const isDualFuel = electric && gas;
  const hasGasSmartMeter =
    gasMeter.smetsVersion === METER_TYPES.S1 ||
    gasMeter.smetsVersion === METER_TYPES.S2;
  const hasElectricitySmartMeter =
    electricityMeter.smetsVersion === METER_TYPES.SMETS1 ||
    electricityMeter.smetsVersion === METER_TYPES.SMETS2;
  const hasDualSmartMeter = hasElectricitySmartMeter && hasGasSmartMeter;

  switch (true) {
    case isDualFuel:
      return {
        hasElectricitySmartMeter,
        hasGasSmartMeter,
        hasAllSmartMeter: hasDualSmartMeter
      };
    case electric:
      return {
        hasElectricitySmartMeter,
        hasAllSmartMeter: hasElectricitySmartMeter
      };
    case gas:
      return {
        hasGasSmartMeter,
        hasAllSmartMeter: hasGasSmartMeter
      };
    default:
      return {};
  }
};

export const getTariffEndDate = (product) => {
  if (!product) {
    return null;
  }

  const { gasTil, electricityTil } = product;
  const tariff = gasTil || electricityTil;
  return tariff?.tariffEndsOn;
};

export const formatTariffDate = (date = '') =>
  moment(date, DATE_FORMAT).format('Do MMMM YYYY');

export const filterFeaturesByTitle = (features = [], excludeTitles = []) => {
  return features.filter(({ title = '' }) => {
    return !excludeTitles.includes(title);
  });
};

export const getFeaturesByTitle = (features = [], titles = []) => {
  return features.filter(({ title: featureTtitle = '' }) =>
    titles.includes(featureTtitle)
  );
};

export const getRadioOptionLabel = (valueParam, options = []) => {
  return options.find(({ value }) => `${valueParam}` === value)?.label;
};

export const isUneligibleMoveInError = (error) =>
  error?.code === MOVE_IN_VERIFY_ERROR_CODES.NotEligibleForMoveInError;

export const RADIO_OPTIONS = [
  {
    label: 'Detailed view',
    value: 'false'
  },
  {
    label: 'Compare prices, rates and charges',
    value: 'true'
  }
];
